import { useState, useEffect } from "react";
import { Accordion, Modal } from "react-bootstrap";
import "./applicants.css";
import axiosInstance from "../../../api/axiosInstance";
import dayjs from "dayjs";


import {newCountry} from "../../../datas/countrydata.json";
type Field = {
  label: string;
  value: string;
  className?: string;
};

type Section = {
  section: string;
  fields: Field[];
};

type Applicant = {
  name: string;
  age: string;
  unifiedNo: string; // will now be used for Passport Number
  fileStatus: string;
  nationality: string;
  expiryDate: string;
  viewDetails: Section[];
  Applicant_Country?: string;
  documents?: any[]; // Add documents array
};
const viewDetails: Section[] = [
  {
    section: "Residency Information",
    fields: [
      {
        label: "Residency Type",
        value: "Residency - Work - Public sector work",
      },
      { label: "Residency File Number", value: "201/454/215159622985" },
      { label: "Residency issue date", value: "01/03/2025" },
      { label: "Residency expiry date", value: "28/02/2027" },
      { label: "Residency status", value: "Active", className: "text-success" },
    ],
  },
  {
    section: "Personal Information",
    fields: [
      { label: "Unified Number", value: "1245781181818" },
      { label: "Full name", value: "Mohammed Saeed Rashid Al Mansoori" },
      { label: "Full name (Arabic)", value: "محمد سعيد راشد المنصوري" },
      { label: "Current nationality", value: "Indian" },
      { label: "Previous Nationality", value: "Indian" },
      { label: "Gender", value: "Male" },
      { label: "Date of Birth", value: "02/02/1990" },
      { label: "Birth Country", value: "India" },
      { label: "Marital Status", value: "Single" },
      { label: "Place of birth", value: "Surat, Gujarat" },
      { label: "Place of birth (Arabic)", value: "سورات، غوجرات" },
      { label: "Mother’s Name", value: "merry" },
      { label: "Mother’s Name (Arabic)", value: "مري" },
      { label: "Religion", value: "Islam" },
      { label: "Profession", value: "Accountant" },
    ],
  },
  {
    section: "Passport Information",
    fields: [
      { label: "Passport Type", value: "Ordinary Passport" },
      { label: "Passport Number", value: "N542154871" },
      { label: "Passport Issue date", value: "05/08/2014" },
      { label: "Passport Expiry date", value: "05/08/2024" },
      { label: "Passport issue country", value: "India" },
    ],
  },
  {
    section: "Address Information",
    fields: [
      { label: "Location Inside UAE", value: "Dubai, UAE" },
      { label: "UAE Mobile no", value: "+971 56 123 45678" },
      { label: "UAE Phone no", value: "+971 56 123 45678" },
      { label: "Applicant location outside UAE", value: "India" },
      { label: "Permanent Mobile No", value: "++971565252457" },
      { label: "Email", value: "demo@gmail.com" },
    ],
  },
];

const orderDetails: { applicants: Applicant[] } = {
  applicants: [
    {
      name: "Mohammed Saeed",
      age: "31 Years",
      unifiedNo: "184254256",
      fileStatus: "Active",
      nationality: "Indian",
      expiryDate: "21/12/2026",
      viewDetails: viewDetails,
    },
    {
      name: "Mohammed Raj",
      age: "31 Years",
      unifiedNo: "184254256",
      fileStatus: "Active",
      nationality: "Indian",
      expiryDate: "21/12/2026",
      viewDetails: viewDetails,
    },
  ],
};
function formatLabel(label: string): string {
  return label
    .replace(/([a-z])([A-Z])/g, '$1 $2') // space before capital
    .replace(/([A-Z])([A-Z][a-z])/g, '$1 $2') // space between capital groups
    .replace(/^./, (str) => str.toUpperCase()); // capitalize first
}
function getCountryNameFromIso(iso: string): string {
  if (!iso) return "";
  const isoUpper = iso.toUpperCase();
  const found = newCountry.find(
    (c: any) => c.iso2 === isoUpper || c.iso3 === isoUpper
  );
  return found ? found.country : iso;
}

export const mapApiApplicantToApplicant = (apiApplicant: any): Applicant => {
  let info: any = {};
  try {
    if (apiApplicant.ApplicantInfoJson) {
      info = JSON.parse(apiApplicant.ApplicantInfoJson);
    }
  } catch (e) {
    info = {};
  }
  let age = "";
  if (info.DateOfBirth) {
    const dob = dayjs(info.DateOfBirth);
    if (dob.isValid()) {
      age = dayjs().diff(dob, "year") + " Years";
    }
  }
  const viewDetails: Section[] = [
    {
      section: "Personal Information",
      fields: [
        { label: "Full name", value: info.Name || apiApplicant.applicant_Name || "" },
        { label: "Date of Birth", value: info.DateOfBirth || "" },
        { label: "Nationality", value: info.Nationality || apiApplicant.Applicant_Country || "" },
        { label: "ID Number", value: info.IDNumber || "" },
        { label: "Place of Birth", value: info.PlaceOfBirth || "" },
      ].filter(f => f.value && f.value !== ""), // Only show fields with data
    },
    {
      section: "Passport Information",
      fields: [
        { label: "Passport Number", value: info.PassportNumber || apiApplicant.Applicant_PassPort || "" },
      ].filter(f => f.value && f.value !== ""), // Only show fields with data
    },
  ];
  const docSections: { [label: string]: Field[] } = {};
  if (Array.isArray(apiApplicant.documents)) {
    apiApplicant.documents.forEach((doc: any) => {
      const label = (doc.LabelName || doc.original_name || "Document").trim();
      if (doc.parsedBody && doc.parsedBody !== "null") {
        let parsed: any = {};
        try {
          parsed = JSON.parse(doc.parsedBody);
        } catch (e) {
          parsed = {};
        }
        if (parsed && typeof parsed === "object") {
          Object.entries(parsed).forEach(([key, value]) => {
            if (
              value === null ||
              key === "MRZ" ||
              key === "isValidDocument"
            ) {
              return; // skip null, MRZ, isValidDocument
            }
            if (!docSections[label]) docSections[label] = [];
            docSections[label].push({ label: formatLabel(key), value: String(value) });
          });
        }
      }
    });
  }
  Object.entries(docSections).forEach(([section, fields]) => {
    const mergedFields: { [label: string]: Field } = {};
    fields.forEach((f) => {
      if (!mergedFields[f.label]) mergedFields[f.label] = f;
    });
    viewDetails.push({ section, fields: Object.values(mergedFields) });
  });

  return {
    name: info.Name || apiApplicant.applicant_Name || "",
    age,
    unifiedNo: info.PassportNumber || apiApplicant.Applicant_PassPort || "", // Passport Number
    fileStatus: "Active",
    nationality: info.Nationality || apiApplicant.Applicant_Country || "",
    expiryDate: info.ExpiryDate || "",
    viewDetails,
    Applicant_Country: apiApplicant.Applicant_Country || "",
    documents: apiApplicant.documents || [], // Include documents array
  };
};
const Applicants = () => {
  const [activeKey, setActiveKey] = useState<string | null>("0");
  const [openModal, setOpenModal] = useState(false);
  const [activeAction, setActiveAction] = useState(""); // "view", "id", "renew", "showall"
  const [selectedApplicant, setSelectedApplicant] = useState<Applicant | null>(
    null
  );

  const [applicants, setApplicants] = useState<Applicant[]>(orderDetails.applicants);

  const [loading, setLoading] = useState<boolean>(true);
  useEffect(() => {
    const fetchApplicants = async () => {
      setLoading(true);
      try {
        const response = await axiosInstance.get(
          "api/user/getAllApplicantList"
        );
        let apiApplicants = [];
        if (response.data && Array.isArray(response.data)) {
          apiApplicants = response.data;
        } else if (response.data && Array.isArray(response.data.applicants)) {
          apiApplicants = response.data.applicants;
        }
        if (apiApplicants.length > 0) {
          setApplicants(apiApplicants.map(mapApiApplicantToApplicant));
        } else {
          setApplicants(orderDetails.applicants);
        }
      } catch (error) {
        setApplicants(orderDetails.applicants);
      } finally {
        setLoading(false);
      }
    };
    fetchApplicants();
  }, []);

  const handleOpenModal = (actionKey: string, applicant: Applicant) => {
    setSelectedApplicant(applicant);
    setActiveAction(actionKey);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setActiveAction("");
    setSelectedApplicant(null);
  };
  
  const [searchText, setSearchText] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const applicantsPerPage = 10;
  const filteredApplicants = applicants.filter((app) => {
    const search = searchText.trim().toLowerCase();
    if (!search) return true;
    return (
      (app.name && app.name.toLowerCase().includes(search)) ||
      (app.unifiedNo && app.unifiedNo.toLowerCase().includes(search)) ||
      (app.nationality && app.nationality.toLowerCase().includes(search))
    );
  });
  const totalApplicants = filteredApplicants.length;
  const totalPages = Math.ceil(totalApplicants / applicantsPerPage);
  const startIdx = (currentPage - 1) * applicantsPerPage;
  const endIdx = startIdx + applicantsPerPage;
  const paginatedApplicants = filteredApplicants.slice(startIdx, endIdx);
  useEffect(() => {
    setCurrentPage(1);
  }, [searchText, applicants]);

  return (
    <div className="row layout-border rounded-3">
      <div className="d-flex justify-content-between align-items-center mb-1 p-3 border-bottom py-2">
        <div>
          <h1 className="ff-semibold text-black mb-1 font-18">Applicants</h1>
        </div>
      </div>
           <div className="p-0 table-search border-bottom d-flex align-items-center gap-2 ps-3 up-form">
          <div>
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 5.59587C1 6.24096 1.12071 6.87974 1.35523 7.47572C1.58975 8.07171 1.93349 8.61323 2.36683 9.06938C2.80018 9.52553 3.31462 9.88737 3.88081 10.1342C4.447 10.3811 5.05383 10.5082 5.66667 10.5082C6.2795 10.5082 6.88634 10.3811 7.45252 10.1342C8.01871 9.88737 8.53316 9.52553 8.9665 9.06938C9.39984 8.61323 9.74358 8.07171 9.97811 7.47572C10.2126 6.87974 10.3333 6.24096 10.3333 5.59587C10.3333 4.95078 10.2126 4.31201 9.97811 3.71603C9.74358 3.12004 9.39984 2.57852 8.9665 2.12237C8.53316 1.66622 8.01871 1.30438 7.45252 1.05752C6.88634 0.810654 6.2795 0.683594 5.66667 0.683594C5.05383 0.683594 4.447 0.810654 3.88081 1.05752C3.31462 1.30438 2.80018 1.66622 2.36683 2.12237C1.93349 2.57852 1.58975 3.12004 1.35523 3.71603C1.12071 4.31201 1 4.95078 1 5.59587Z"
                stroke="#9B9B9B"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M13 13.316L9 9.10547"
                stroke="#9B9B9B"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <input
            type="text"
            className="form-control myorders-search p-0 border-0 rounded-0 mb-0"
            placeholder="Search Name, Passport Number, Country"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
        </div>
      <div className="p-3">
        {loading ? (
          <div className="text-center py-5">Loading applicants...</div>
        ) : (
          <Accordion activeKey={activeKey ?? ""}>
            {paginatedApplicants.map((app, idx) => {
              const key = String(startIdx + idx);
              const isActive = activeKey === key;

              return (
                <Accordion.Item
                  eventKey={key}
                  key={key}
                  className="mb-3 rounded-3 py-3 px-3 border applicant-listing-wrap"
                >
                  <Accordion.Header
                    onClick={() => setActiveKey(isActive ? null : key as string | null)}
                    className="border-0"
                  >
                    <div className="d-flex justify-content-between align-items-center w-100">
                      <div
                        className="d-flex align-items-center gap-3"
                        style={{ width: "30%" }}
                      >
                        {/* <img
                          src="https://randomuser.me/api/portraits/men/75.jpg"
                          alt="Profile"
                          className="rounded-circle"
                          width="50"
                          height="50"
                        /> */}
                         <span
                                className={`rounded-circle flag-icon flag-icon-${
                                    app.Applicant_Country
                                      ? app.Applicant_Country.toLowerCase()
                                    : "ae"
                                } me-1`}  style={{width: "50px", height: "50px"}}></span>
                        <div className="d-flex flex-column">
                          <div className="text-muted font-12 ff-medium mb-2">
                            Name
                          </div>
                          <div className="text-primary font-14 ff-semibold">
                            {app.name}
                          </div>
                        </div>
                      </div>

                      <div className="text-end">
                        <div className="text-muted font-12 ff-medium mb-2">
                          Passport
                        </div>
                        <div className="text-black font-14 ff-semibold">
                          {app.unifiedNo}
                        </div>
                      </div>

                      <div className="text-end">
                        <div className="text-muted font-12 ff-medium mb-2">
                          File Status
                        </div>
                        <div className="text-black font-14 ff-semibold">
                          {app.fileStatus}
                        </div>
                      </div>
                      <div className="ms-3 accordion-arrow-icon">
                        <svg
                          width="13"
                          height="8"
                          viewBox="0 0 13 8"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M1 1.5L6.5 7L12 1.5"
                            stroke="black"
                            strokeWidth="1.25"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          ></path>
                        </svg>
                      </div>
                    </div>
                  </Accordion.Header>

                  <Accordion.Body>
                    <div className="row  p-3 bg-2 my-3">
                      <div className="col-md-3 d-none">
                        <p className="font-12 ff-medium text-muted mb-0">
                          Expiry Date:{" "}
                          <span className="ff-semibold text-black font-14">
                            {app.expiryDate}
                          </span>
                        </p>
                      </div>
                      <div className="col-md-3">
                        <p className="font-12 ff-medium text-muted mb-0">
                          Nationality:{" "}
                          <span className="ff-semibold text-black font-14">
                            {getCountryNameFromIso(app.nationality)}
                          </span>
                        </p>
                      </div>
                    </div>
                    <div className="d-flex align-items gap-4">
                      <div
                        className="d-flex align-items-center gap-2 bg-3 layout-border rounded-2 px-3 py-2 details-modal-btn-new"
                        onClick={() => handleOpenModal("view", app)}
                      >
                        <img
                          src="https://goodhand.b-cdn.net/Assets/Upload/eye.svg"
                          alt=""
                        />
                        <div className="font-13 ff-medium text-main">View</div>
                      </div>

                      <div
                        className="d-flex align-items-center gap-2 bg-3 layout-border rounded-2 px-3 py-2 details-modal-btn-new d-none"
                        onClick={() => handleOpenModal("id", app)}
                      >
                        <img
                          src="https://goodhand.b-cdn.net/Assets/Upload/identity.svg"
                          alt=""
                        />
                        <div className="font-13 ff-medium text-main">ID Card</div>
                      </div>

                      <div
                        className="d-flex align-items-center gap-2 bg-3 layout-border rounded-2 px-3 py-2 details-modal-btn-new d-none"
                        onClick={() => handleOpenModal("renew", app)}
                      >
                        <img
                          src="https://goodhand.b-cdn.net/Assets/Upload/renew-id.svg"
                          alt=""
                        />
                        <div className="font-13 ff-medium text-main">
                          Renew Emirates ID
                        </div>
                      </div>

                      <div
                        className="d-flex align-items-center gap-2 bg-3 layout-border rounded-2 px-3 py-2 details-modal-btn-new d-none"
                        onClick={() => handleOpenModal("showall", app)}
                      >
                        <img
                          src="https://goodhand.b-cdn.net/Assets/Upload/ShowAll.svg"
                          alt=""
                        />
                        <div className="font-13 ff-medium text-main">
                          Show All
                        </div>
                      </div>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              );
            })}
          </Accordion>
        )}
      </div>
      <nav className="d-flex justify-content-center mt-4">
        <ul className="pagination custom-pagination1">
          {/* Previous button */}
          <li className={`page-item${currentPage === 1 ? " disabled" : ""}`}>
            <button
              className="page-link rounded-circle"
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
              aria-label="Previous"
            >
              <svg
                width="8"
                height="12"
                viewBox="0 0 8 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.5 0.785156L1.5 5.78516L6.5 10.7852"
                  stroke="#9A9A9A"
                  strokeWidth="1.25"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          </li>
          {/* Page numbers */}
          {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
            <li
              key={page}
              className={`page-item${currentPage === page ? " active" : ""}`}
            >
              <button
                className="page-link rounded-circle"
                onClick={() => setCurrentPage(page)}
                disabled={currentPage === page}
              >
                {page}
              </button>
            </li>
          ))}
          {/* Next button */}
          <li className={`page-item${currentPage === totalPages || totalPages === 0 ? " disabled" : ""}`}>
            <button
              className="page-link rounded-circle"
              onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
              disabled={currentPage === totalPages || totalPages === 0}
              aria-label="Next"
            >
              <svg
                width="16"
                height="16"
                fill="currentColor"
                viewBox="0 0 16 16"
              >
                <path
                  d="M5 1l8 7-8 7"
                  stroke="currentColor"
                  strokeWidth="2"
                  fill="none"
                />
              </svg>
            </button>
          </li>
        </ul>
      </nav>
      <div>
        <Modal
          centered
          show={openModal}
          scrollable
          onHide={handleCloseModal}
          backdrop="static"
          dialogClassName="wide-modal"
          className="mb-fix slide-from-bottom"
        >
          <Modal.Header closeButton />
          <Modal.Body className="rounded pb-4 modal-dialog-scrollable custom-modal-dialog">
            {/* CONDITIONAL CONTENT BLOCKS */}
            {activeAction === "view" && selectedApplicant && (
              <div className="">
                {/* Header */}
                <div className="d-flex align-items-center gap-3 mb-4 border-dashed pb-4">
                  {/* <img
                    src="https://randomuser.me/api/portraits/men/75.jpg"
                    alt="Profile"
                    className="rounded-circle"
                    width="60"
                    height="60"
                  /> */}
                  <span
                                className={`rounded-circle flag-icon flag-icon-${
                                    selectedApplicant?.Applicant_Country
                                      ? selectedApplicant.Applicant_Country.toLowerCase()
                                    : "ae"
                                } me-1`}  style={{width: "50px", height: "50px"}}></span>
                      
                  <div>
                    <h5 className="mb-0 ff-semibold text-uppercase font-18">
                      {selectedApplicant.name}
                    </h5>
                    <p className="text-muted mb-0 ff-medium font-14">
                      Age : {selectedApplicant.age}
                    </p>
                  </div>
                </div>
                <Accordion defaultActiveKey="0" className="mb-3">
                  {selectedApplicant.viewDetails.map((sectionData, index) => (
                    <Accordion.Item
                      key={index}
                      eventKey={String(index)}
                      className="border rounded-3 mb-3 applicant-view"
                    >
                      <Accordion.Header>
                        <div className="d-flex w-100 align-items-center justify-content-between gap-3">
                          <span className="fw-semibold text-dark font-14">
                            {sectionData.section}
                          </span>
                          <div className="ms-3 accordion-arrow-icon">
                            <svg
                              width="13"
                              height="8"
                              viewBox="0 0 13 8"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M1 1.5L6.5 7L12 1.5"
                                stroke="black"
                                strokeWidth="1.25"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              ></path>
                            </svg>
                          </div>
                        </div>
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="p-3">
                          {sectionData.fields.map((field, idx) => (
                            <div className="mb-3" key={idx}>
                              <div className="text-muted font-12">
                                {field.label}
                              </div>
                              <div
                                className={`fw-semibold font-13 ${
                                  field.className ? field.className : ""
                                }`}
                              >
                                {field.value}
                              </div>
                            </div>
                          ))}
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  ))}
                </Accordion>
              </div>
            )}

            {activeAction === "id" && selectedApplicant && (
              <div className="px-2">
                <p className="font-20 ff-semibold text-black">
                  Are you sure you want to cancel the ?
                </p>
                <div className="layout-border p-2 rounded-3">
                  <div className="d-flex align-items-center justify-content-between border-dashed pb-2">
                    <div>
                      <p className="ff-semibold font-14 text-black mb-0">
                        Employee Visa Package
                      </p>
                    </div>
                    <div className="d-flex align-items-center gap-2">
                      <div className="bg-light-green ff-semibold text-green font-11 p-2 py-1 d-flex align-items-center rounded">
                        Refundable
                      </div>
                      <div className="font-14 ff-semibold text-black">
                        <span className="me-1">AED </span>458
                      </div>
                    </div>
                  </div>
                  <div className="cart-options mb-1">
                    <p className="options-title ff-medium text-black my-2 font-13">
                      Options Selected for visa
                    </p>
                    <div className="options-list d-flex gap-2">
                      <span className="option category px-2 py-1 rounded-pill bg-3 text-main ff-semibold font-12 ">
                        Employee
                      </span>
                      <span className="option category px-2 py-1 rounded-pill bg-3 text-main ff-semibold font-12 ">
                        Inside
                      </span>
                    </div>
                  </div>
                </div>

                <div className="d-flex align-items-center justify-content-between mt-3 pb-2">
                  <div>
                    <p className="ff-semibold font-14 text-black mb-0">
                      Total refundable amount
                    </p>
                  </div>
                  <div className="d-flex align-items-center gap-2">
                    <div className="font-14 ff-semibold text-black">
                      <span className="me-1">AED </span>458
                    </div>
                  </div>
                </div>

                <div className="visa-info-banner bg-beige text-noti font-11 p-2 px-2 my-2 ff-medium d-flex align-items-center justify-content-between gap-2 rounded-0">
                  <div className="d-flex align-items-center gap-1">
                    <span>
                      Note : Once you cancel the service, your total payable
                      amount will be refunded to the card or bank account used
                      for the transaction.
                    </span>
                  </div>
                </div>
              </div>
            )}

            {activeAction === "renew" && selectedApplicant && (
              <div>
                <p className="text-center">
                  Renew Emirates ID for {selectedApplicant.name}
                </p>
              </div>
            )}

            {activeAction === "showall" && selectedApplicant && (
              <div>
                <div className="d-flex align-items-center gap-3 mb-4 border-dashed pb-4">
                  <img
                    src="https://randomuser.me/api/portraits/men/75.jpg"
                    alt="Profile"
                    className="rounded-circle"
                    width="60"
                    height="60"
                  />
                  <div>
                    <h5 className="mb-0 ff-semibold text-uppercase font-18">
                      {selectedApplicant.name}
                    </h5>
                    <p className="text-muted mb-0 ff-medium font-14">
                      Age : {selectedApplicant.age}
                    </p>
                  </div>
                </div>

                <div className="showall-option-list border rounded-4 overflow-hidden">
                  {[
                    "View",
                    "ID Card",
                    "Renew Emirates ID",
                    "Replace Emirates ID",
                    "Update Personal Info",
                    "View current & old file information",
                  ].map((option, idx) => (
                    <div
                      key={idx}
                      className="showall-option-item d-flex justify-content-between align-items-center px-3 py-3  border-bottom"
                    >
                      <span className="font-14 text-black ff-semibold">
                        {option}
                      </span>
                      <svg
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M5.25 3.5L8.75 7L5.25 10.5"
                          stroke="#222"
                          strokeWidth="1.4"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );
};

export default Applicants;
